/**
 * PWA Intranet
 * update 07/2022
 * By Sergio Sam 
 */

import React from "react";
import ReactDOM from 'react-dom/client';

import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './components/AuthContext';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { theme } from './components/styles';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(


  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  </StyledEngineProvider>

);

serviceWorkerRegistration.register();
reportWebVitals();

